import "./common.scss";
import { ReactComponent as CloseIcon } from "../../Assets/Icons/popupCloseIcon.svg";
import PrimaryButton from "./PrimaryButton";

const AlreadyRegisteredPopup = ({
  handleClose,
  content = "This email address is currently registered to Dairy Bell. Would you like to create a second business, with the same email?",
  popupClassName = "",
  title = "Email Already Registered",
  primaryButtonText = "Yes, create Dairy Blend",
  secondaryButtonText = "No, use a different email",
  onPrimaryClick,
  onSecondaryClick,
}) => {
  return (
    <div className="popup-container">
      <div
        className={`popup flex flex-col items-center bg-white rounded-[10px] drop-shadow-[0_3px_3px_rgba(0,0,0,0.25)] relative ${popupClassName}`}
      >
        {handleClose && (
          <div
            className="absolute top-[-12px] right-[-12px] cursor-pointer bg-[#00ADEF] rounded-full p-1.5 popup-close-icon flex items-center justify-center"
            onClick={handleClose}
          >
            <CloseIcon className="w-[18px] h-[18px] scale-75" />
          </div>
        )}
        {content}
      </div>
    </div>
  );
};

export default AlreadyRegisteredPopup;
